var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page container text-center"},[(_vm.error.statusCode === 404)?_c('h1',[_vm._v("\n    Страница не найдена\n  ")]):[_c('h1',[_vm._v("Error...")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.error.message))])],_vm._v(" "),_c('a',{attrs:{"href":_vm.homeUrl}},[_vm._v("\n    на главную\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }